import {useLogger, useUniversalFetch} from '#imports';
import type {HostFeaturesResource} from '../types';

export function useHostFeatures() {
    const logger = useLogger();

    function getHostFeatures(): Promise<HostFeaturesResource | undefined> {
        return useUniversalFetch<HostFeaturesResource>('/api/host-features/current').catch((error: unknown) => {
            logger.error(`Error while fetching host features: ${error}`);
            return undefined;
        });
    }

    return {
        getHostFeatures,
    };
}
